<div class="vh-100 root-div">
  <app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
  <!-- <div class="spinner-border text-danger" role="status">
    <span class="visually-hidden">Loading...</span>
  </div> -->
  <div class="d-flex justify-content-center spinner" *ngIf="loadingService.loading$ | async">
    <div class="spinner-border text-danger" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  <router-outlet></router-outlet>
</div>
 <!-- Global Loader Spinner -->
 <!-- <div class="spinner" *ngIf="loadingService.loading$ | async">
  <div class="dots">
    <span style="--i: 1"></span>
    <span style="--i: 2"></span>
    <span style="--i: 3"></span>
    <span style="--i: 4"></span>
    <span style="--i: 5"></span>
    <span style="--i: 6"></span>
    <span style="--i: 7"></span>
    <span style="--i: 8"></span>
    <span style="--i: 9"></span>
    <span style="--i: 10"></span>
    <span style="--i: 11"></span>
    <span style="--i: 12"></span>
    <span style="--i: 13"></span>
    <span style="--i: 14"></span>
    <span style="--i: 15"></span>
  </div>
</div> -->
